<template>
  <div class="calico-status-card-page">
    <h1>Calico Statis Cards</h1>
    <div class="container">
      <div class="div">
        <CalicoStatusCard
          v-model="groupValue"
          value="card1"
          title="Custom Title"
          description="This is a custom description for card 1."
          badge-label="ToDo"
          badge-color="light-black"
        />
        <CalicoStatusCard
          v-model="groupValue"
          value="card2"
          title="Custom Title"
          description="This is a custom description for card 2."
          badge-label="In Progress"
          badge-color="light-yellow"
        />
        <CalicoStatusCard
          v-model="groupValue"
          value="card3"
          title="Custom Title"
          description="This is a custom description for card 3."
          badge-label="Complete"
          badge-color="light-green"
        />
        <CalicoStatusCard
          v-model="groupValue"
          value="card4"
          :disabled="true"
          title="Custom Title"
          description="This is a custom description for card 4."
          badge-label="Error"
          badge-color="light-red"
        />
      </div>
    </div>
  </div>
</template>
  
  <script>
  import CalicoStatusCard from '@/components/calico/statusCard/index.vue';
  
  export default {
    name: 'CalicoStatusCardPageView',
    components: {
      CalicoStatusCard,
    },
    data() {
      return {
        groupValue: null,
      };
    },
  };
  </script>
  
  <style lang="scss">
  .calico-status-card-page {
    margin: 30px;
  
    .div {
      display: flex;
      flex-direction: row;
      width: 100%;
      gap: 20px;
    }
  }
  </style>
  